'use client'

import SliderWrapper from '@/components/sliderWrapper';
import { IconChevronRight } from '@tabler/icons-react';
import Image from 'next/image';
import Link from 'next/link';
import { Settings } from 'react-slick';
import NextLink from './NextLink';
const settings: Settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    draggable: true,
    fade: true,
    autoplaySpeed: 3000,
    appendDots: dots => {
        return (
            <div
                className='flex items-center gap-2'
            >
                {dots && Array.isArray(dots) && dots.map((item, index) => <ul key={index} className='w-1.5 mb-2 rounded-full aspect-square !bg-white/90' >  </ul>)}
            </div>
        )
    },
    dotsClass: 'absolute bottom-0  right-0 w-full !flex justify-center'
};

export default function Banners({ wpUrl }: { wpUrl: string }) {
    return (
        <div className=' h-full w-full mx-auto md:hidden'>


            <div className="py-4 relative z-50 bg-gradient-to-r from-[#9772F4] to-[#6C3FED] h-full overflow-hidden px-4 items-center rounded-xl
                            !grid grid-cols-[145px,_1fr] ">
                <div className='flex flex-col gap-2'>
                    <p className='text-white text-xl font-bold w-48'>
                        Ready for an amazing stay?
                    </p>
                    <Link href={'/itineraries'} className='flex items-center min-w-max relative z-20 py-0.5 text-xs font-bold bg-[#FFC5B0] justify-center rounded-full gap-2 text-indigo-900 w-full'>
                        <span>
                            Make Your Trip
                        </span>
                        <IconChevronRight className='w-5' />
                    </Link>
                </div>
                <div className=' h-full  flex justify-end'>
                    <Image alt='Itinerary banner' width={300}
                        className='absolute w-1/2 right-0 top-1/2 translate-x-[5%] -translate-y-1/2 scale-[120%]'
                        height={400}
                        src={`${wpUrl}/2024/08/mobile-banner-hotel2.png`} />
                </div>
            </div>

        </div>
    );
}